import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { withStyles, Tooltip, IconButton, Typography, CircularProgress, Button, Dialog, DialogTitle, Grid, } from '@material-ui/core';
import { informationColors } from '../../../themes';
import { hasPermission, createHistory, parseURL, hasAtLeastOnePermission } from '../../sc-utilities';
import { Redirect } from 'react-router-dom';
import { FindInPage, Restore, LibraryBooks, Dvr, DevicesOther, SdCard, History, CloudUpload, AllInbox } from '@material-ui/icons';
import * as actions from './store/colliActions';
import ColliList from './ColliList';
import ActiveWarehouseForm from './ActiveWarehouseForm';
import * as groupActions from "../../sc-group/Group/store/groupActions";
import * as pcActions from '../../sc-product/PCProduct/store/pcProductActions';
import AppLogoLoading from "../../sc-logo";
import { getGroupsLookup } from '../../sc-dashboard/ProductOverview/ProductsAll';
import { checkIfLoading } from "../../sc-users/User";
import ExportForm from '../../sc-components/ExportForm/ExportForm';
import ConfirmationDialog from '../../np-components/ConfirmationDialog/ConfirmationDialog';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    progressBarr: {
        width: '100%',
        height: 5
    },
    paletteButtons: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.buttonText.default,
        margin: theme.spacing(),
        minWidth: '24px',
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    "@global": {
        "[class*='buttonsCustomer']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            minWidth: '24px',
            borderRadius: '1px',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                textDecoration: 'none'

            },
        },
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
        "[class*='warning']": {
            color: theme.palette.warning.light,
            padding: 1,
            fontSize: 12
        },
        "[class*='error']": {
            color: theme.palette.dark,
            padding: 1,
            fontSize: 12
        },
        "[class*='success']": {
            color: theme.palette.success.main,
            padding: 1,
            fontSize: 12
        }
    },
    warning: {
        color: theme.palette.warning.light
    },
    error: {
        color: theme.palette.error.dark,
    },
    success: {
        color: theme.palette.success.main
    },
    loading: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    }
});

let initialValues = [
    'Excel',
    'JSON',
    'CSV',
    'XML',
    'Download',
    "Email",
    "includePDFReports",
    "includeDiagnoseReports",
    "includeVerificationReports",
    "includeAggregatedPDFErasureReports",
    "includeAggregatedPDFVerificationReports",
    "includeSummaryPDFErasureReports",
    "includeSummaryPDFVerificationReports",
];

let colliID = null;
let colliInventoryID = null;
let warehouseInventoryID = null;

const Colli = props => {
    const tableRef = useRef();
    const { classes, columns, translations, setActiveWarehouse, onGenerateReport, onFetchColliType, onFetchWarehouse, activeWarehouseID, permissions, activeCustomer, onRestoreColli, onFetchGrades, onFetchProductType, fetchGroups, onSendExternalData, onSendErasureReports } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, colliID: null, redirectPath: '', search: '', warehouseID: null });
    const [grades, setGrades] = useState(null);
    let searchParams = parseURL(window.location.search);
    const [warehouseActive, setWarehouseActive] = useState({ open: false, data: [], name: [], loading: false });
    const [colliTypes, setColliTypes] = useState(null);

    const [productTypes, setProductTypes] = useState(null);
    const [groups, setGroups] = useState(null);
    const [loading, setLoading] = useState({ groups: false });

    const [collectionCreatePopupIsOpen, setCollectionCreatePopupIsOpen] = useState(false);
    const [rowData, setRowData] = useState(null)
    const [confirmDialog, setConfirmDialog] = useState({ open: false, confirmed: false, type: '', title: '' });

    const handleOpenDialog = (rowData, type, title) => {
        setConfirmDialog({ open: true, type, title });
        setRowData(rowData);  
    };

    const formSettings = {
        Validation: {},
        FormTitle: translations["create_collection"] || "Create collection",
        ButtonSubmit: {
            Title: translations["download"] || "Download",
            Color: 'primary'
        },
        InitialValues: { GroupID: groups?.map(group => group.value)?.includes('n/a') ? 'n/a' : groups?.[0]?.value ?? null }
    };

    let visible = columns && columns['Colli'];

    useEffect(() => {
        const fetchGrades = async () => {
            let gradeData = await onFetchGrades({ ActiveCustomerID: activeCustomer });

            let formattedGrades = gradeData.reduce(
                (obj, item) => Object.assign(obj, { [item.label]: item.label }), {});
            setGrades(formattedGrades);
        };

        const fetchProductTypes = async () => {
            let productTypeData = await onFetchProductType({ ActiveCustomerID: activeCustomer });
            let formattedProductTypes = productTypeData.reduce(
                (obj, item) => Object.assign(obj, { [item.key]: item.label }), {});
            setProductTypes(formattedProductTypes);
        };


        const fetchColliTypes = async () => {
            let colliTypeData = await onFetchColliType({ ActiveCustomerID: activeCustomer, q: { WarehouseID: activeWarehouseID } });
            let formattedColliTypes = colliTypeData.reduce(
                (obj, item) => Object.assign(obj, { [item.label]: item.label }), {});
            setColliTypes(formattedColliTypes);
        };

        const fetchWarehouse = async () => {
            let warehouses = await onFetchWarehouse({ ActiveCustomerID: activeCustomer });
            let data
            if (!activeWarehouseID && !(searchParams && searchParams.WarehouseInventoryID)) {
                if (warehouses.length > 1) {
                    setWarehouseActive({ loading: true, open: true, data: warehouses, name: warehouses })
                }
                if (warehouses.length === 1) {
                    await setActiveWarehouse({ ActiveCustomerID: activeCustomer, ActiveWarehouseID: warehouses[0].value })
                    data = warehouses.filter(data => data.value === activeWarehouseID)
                    setWarehouseActive({ loading: true, open: false, data: warehouses, name: warehouses })
                }
                if (warehouses.length === 0) {
                    setWarehouseActive({ loading: true, open: false, data: [], name: [] })
                }
            }
            if (activeWarehouseID && !(searchParams && searchParams.WarehouseInventoryID)) {
                if (warehouses.length > 0) {
                    data = warehouses.filter(params => params.value === activeWarehouseID)
                    setWarehouseActive({ loading: true, open: false, data: warehouses, name: data })
                }
                if (warehouses.length === 0) {
                    setWarehouseActive({ loading: true, open: false, data: [], name: [] })
                }
                if (warehouses.length === 1) {
                    await setActiveWarehouse({ ActiveCustomerID: activeCustomer, ActiveWarehouseID: warehouses[0].value })
                    setWarehouseActive({ loading: true, open: false, data: warehouses, name: warehouses })
                }
            }
            if (searchParams && searchParams.WarehouseInventoryID) {
                if (warehouses.length > 1) {
                    data = warehouses.filter(params => params.inventoryID.toString() === searchParams.WarehouseInventoryID)
                    setWarehouseActive({ loading: true, open: false, data: warehouses, name: data })
                }
                if (warehouses.length === 0) {
                    setWarehouseActive({ loading: true, open: false, data: [], name: [] })
                }
                if (warehouses.length === 1) {
                    await setActiveWarehouse({ ActiveCustomerID: activeCustomer, ActiveWarehouseID: warehouses[0].value })
                    setWarehouseActive({ loading: true, open: false, data: warehouses, name: warehouses })
                }
            }
        };

        fetchColliTypes()
        fetchGrades();
        fetchWarehouse();
        fetchProductTypes();
        return () => { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeWarehouseID]);
    const filterHolderColli = async (id) => {
        window.parent.location = `/logistic/container?HolderColliInventoryID=${id}`;
    }

    useEffect(() => {
        const getGroups = async () => {
            setLoading(prevState => { return { ...prevState, groups: true } });
            const resultGroups = await fetchGroups({ ActiveCustomerID: activeCustomer });
            if (resultGroups) {
                setGroups(resultGroups.data);
            }
            setLoading(prevState => { return { ...prevState, groups: false } });
        }

        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
        // eslint-disable-next-line
    }, []);

    const groupsLookup = getGroupsLookup(groups, translations, permissions);

    const sendExternalData = useCallback(async (colliID) => {
        await onSendExternalData({ ColliID: colliID, ActiveCustomerID: activeCustomer })
    }, [activeCustomer, onSendExternalData]);

    const sendErasureReports = useCallback(async (colliID) => {
        await onSendErasureReports({ ColliID: colliID, ActiveCustomerID: activeCustomer })
    }, [activeCustomer, onSendErasureReports]);

    useEffect(() => {
        if (confirmDialog.confirmed) {
            if (confirmDialog.type === 'data') {
                sendExternalData(rowData.ColliID);
            } else if (confirmDialog.type === 'report') {
                sendErasureReports(rowData.ColliID);
            }
        }
    }, [confirmDialog.confirmed, confirmDialog.type, rowData?.ColliID, sendExternalData, sendErasureReports]);

    const tableActionsRow = [
        {
            icon: 'FindInPage',
            tooltip: translations['colli_details'] || 'Colli details',
            onClick: (event, rowData) => goToColliDetails(event, rowData),
            hidden: !hasPermission(permissions, 'colli_load')
        },
        {
            icon: 'RestoreIcon',
            tooltip: translations['colli_restore'] || 'Colli restore',
            onClick: (event, rowData) => restoreColli(event, rowData),
            hidden: !hasPermission(permissions, 'colli_palette_restore')
        },
        {
            icon: 'LibraryBooks',
            tooltip: translations['create_collection'] || 'Create collection',
            onClick: (event, rowData) => {
                setRowData(rowData);
                setCollectionCreatePopupIsOpen(true);
            },
            hidden: !hasPermission(permissions, 'colli_generate_report'),
        },
        {
            icon: 'Dvr',
            tooltip: translations['go_to_pc_products'] || 'Go to PC products',
            onClick: (event, rowData) => goToPCProducts(event, rowData),
            hidden: !hasPermission(permissions, 'colli_list')
        },
        {
            icon: 'DevicesOther',
            tooltip: translations['go_to_mobile_products'] || 'Go to mobile products',
            onClick: (event, rowData) => goToMobileProducts(event, rowData),
            hidden: !hasPermission(permissions, 'colli_list')
        },
        {
            icon: 'SdCard',
            tooltip: translations['go_to_storage_products'] || 'Go to storage products',
            onClick: (event, rowData) => goToStorageProducts(event, rowData),
            hidden: !hasPermission(permissions, 'colli_list')
        },
        {
            icon: 'CloudUpload',
            tooltip: translations['send_external_data'] || "Send external data",
            onClick: (event, rowData) => handleOpenDialog(rowData, 'data', translations['sure_want_to_resend_data_for_sale_lot'] || `Are you sure you want to re-send data for the whole Sale Lot?`),
            hidden: !hasPermission(permissions, 'product_send_external_data')
        },
        {
            icon: 'AllInbox',
            tooltip: translations['send_erasure_reports'] || "Send erasure reports",
            onClick: (event, rowData) => handleOpenDialog(rowData, 'report', translations['sure_want_to_resend_reports_for_sale_lot'] || `Are you sure you want to re-send erasure reports for the whole Sale Lot?`),
            hidden: !hasPermission(permissions, 'product_send_erasure_report')
        },
        {
            icon: 'History',
            tooltip: translations["colli_history"] || "Colli History",
            onClick: (event, rowData) => goToColliHistory(event, rowData),
            hidden: !hasPermission(permissions, "colli_history_list")
        }
    ];


    const getIcon = icon => {
        switch (icon) {
            case 'FindInPage':
                return <FindInPage id={`colli_details_${colliID}`} />
            case 'RestoreIcon':
                return <Restore id={`restore_colli_${colliID}`} />
            case 'LibraryBooks':
                return <LibraryBooks id={`generate_report_${colliInventoryID}`} />
            case 'Dvr':
                return <Dvr id={`goto_pc_${colliInventoryID}`} />
            case 'DevicesOther':
                return <DevicesOther id={`goto_mobile_${colliInventoryID}`} />
            case 'SdCard':
                return <SdCard id={`goto_storage_${colliInventoryID}`} />
            case 'History':
                return <History id={`goto_colli_history_${warehouseInventoryID}`} />
            case 'CloudUpload':
                return <CloudUpload id={`send_external_data_${colliID}`} />
            case 'AllInbox':
                return <AllInbox id={`send_erasure_reports_${colliID}`} />
            default:
                return <> </>
        }
    }

    const checkIfHasFinished = (history) => {
        let hasFinished = false;
        history.map(element => {
            if (element.Finished) hasFinished = true;
            return null;
        });
        return hasFinished;
    };

    const tableColumns = useMemo(() => {
        return [
            {
                title: translations["action"] || "Action", field: 'ColliID',
                hidden: visible ? visible['ColliID'] : false,
                cellStyle: { minWidth: 240, maxWidth: 240 },
                filtering: false,
                render: rowData => {
                    colliID = rowData.ColliID;
                    colliInventoryID = rowData.ColliInventoryID;
                    warehouseInventoryID = rowData.Warehouse.WarehouseInventoryID;
                    rowData.Deleted === true ? tableActionsRow[1].hidden = false : tableActionsRow[1].hidden = true
                    return tableActionsRow.map(action => {
                        if (action.hidden) {
                            return null;
                        }
                        return (
                            <Tooltip key={`${action.icon}-${rowData.ColliID}`} title={action.tooltip}>
                                <IconButton
                                    component='div'
                                    onClick={(event) => action.onClick(event, rowData)}
                                >
                                    {
                                        getIcon(action.icon)
                                    }
                                </IconButton>
                            </Tooltip>
                        )
                    })
                }
            },

            {
                title: translations["id"] || "ID", field: 'ColliInventoryID',
                hidden: visible ? visible['ColliInventoryID'] : false,
                cellStyle: { minWidth: 140, maxWidth: 140 },
                defaultFilter: searchParams && searchParams.ColliInventoryID ? searchParams.ColliInventoryID : '',
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.ColliInventoryID ? rowData.ColliInventoryID : translations['short_not_assigned'] || 'n/a'}</Typography>;
                },
            },
            {
                title: translations["name"] || 'Name', field: 'Name',
                hidden: visible ? visible['Name'] : false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["colli_type"] || 'Colli type', field: 'ColliTypeName',
                hidden: visible ? visible['ColliTypeName'] : false,
                lookup: colliTypes,
                filterCellStyle: { minWidth: 170, maxWidth: 170 },
                filtering: true,
                render: rowData => {
                    return rowData.ColliType ? <Button
                        color="primary"
                        variant="contained"
                        className={classes.paletteButtons}
                        onClick={() => redirectHandler('/logistic/colli-type', `ColliTypeName=${encodeURIComponent(rowData.ColliType.Name)}&&WarehouseInventoryID=${rowData.Warehouse.WarehouseInventoryID}`, rowData.Warehouse.WarehouseID, null, rowData?.Warehouse?.WarehouseInventoryID)}
                    >
                        <Typography variant={'caption'}>{rowData.ColliType.Name}</Typography>
                    </ Button> : <Typography variant={'caption'}> n/a </Typography>;
                }
            },
            {
                title: translations["description"] || 'Description', field: 'Description',
                hidden: visible ? visible['Description'] : false,
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Description ? rowData.Description : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["status"] || 'Status', field: 'Status',
                hidden: visible ? visible['Status'] : false,
                cellStyle: { minWidth: 220, maxWidth: 220 },
                filtering: false,
                render: rowData => {
                    return <>
                        <CustomChip
                            className={'success'}
                            key={'products_registered'}
                            value={`${translations['products_registered'] || "Products Registered:"} ${rowData.NumberOfProducts}`}
                        />
                        <CustomChip
                            className={'success'}
                            key={'products_without_storages'}
                            value={`${translations['products_without_storages'] || "Products without storages:"} ${rowData.NumberOfProductsWithoutStorages}`}
                        />
                        <CustomChip
                            className={rowData.NumberOfErasedStorages === rowData.NumberOfStorages ? 'success' : 'warning'}
                            key={'storages_erased'}
                            value={`${translations['storages_erased'] || "Storages erased:"} ${rowData.NumberOfErasedStorages} / ${rowData.NumberOfStorages}`}
                        />
                        <CustomChip
                            className={rowData.NumberOfProductsWithoutStorages === 0 ? 'success' : 'error'}
                            key={'storages_failed_to_erase'}
                            value={`${translations['storages_failed_to_erase'] || "Storages failed to erase"}: ${rowData.NumberOfFailedToEraseStorages}`}
                        />
                    </>
                }
            },
            {
                title: translations["location"] || 'Location', field: 'HolderColliID',
                hidden: visible ? visible['HolderColliID'] : false,
                filtering: true,
                defaultFilter: searchParams && searchParams.HolderColliInventoryID ? searchParams.HolderColliInventoryID : '',
                selection: true,
                render: rowData => {
                    return rowData.ColliType ? <Button
                        color="primary"
                        variant="contained"
                        className={classes.paletteButtons}
                        disabled={!(rowData?.HolderColli?.ColliInventoryID)}
                        onClick={() => filterHolderColli(rowData?.HolderColli?.ColliInventoryID)}
                    >
                        <Typography variant={'caption'}>{rowData.HolderColli ? rowData.HolderColli.ColliInventoryID : ''} ({rowData?.ColliType?.Name})</Typography>
                    </ Button> : <Typography variant={'caption'}> n/a </Typography>;
                }
            },
            {
                title: translations["group"] || 'Group', field: 'GroupID',
                cellStyle: { minWidth: 100, maxWidth: 100 },
                hidden: visible ? visible['GroupID'] : false,
                lookup: groupsLookup,
                defaultFilter: searchParams?.GroupID ? [searchParams.GroupID] : groups ? Object.keys(groupsLookup) : [],
                render: rowData => {
                    return <Typography style={{ fontSize: 12 }} gutterBottom>{rowData?.Group ? rowData.Group?.Name : (translations['short_not_assigned'] || 'n/a')}</Typography>
                }
            },
            {
                title: translations["finished"] || 'Finished', field: 'Finished',
                hidden: visible ? visible['Finished'] : false,
                lookup: { '1': translations['finished'] || 'Finished', '0': translations['unfinished'] || 'Unfinished' },
                defaultFilter: ['0', '1'],
                cellStyle: { minWidth: 130, maxWidth: 130 },
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{checkIfHasFinished(rowData.History) ? translations['finished'] || 'Finished' : translations['unfinished'] || 'Unfinished'}</Typography>;
                }
            },
            {
                title: translations["locked"] || 'Locked', field: 'Locked',
                hidden: visible ? visible['Locked'] : false,
                lookup: { '1': translations['yes'] || 'Yes', '0': translations['no'] || 'No' },
                defaultFilter: ['1', '0'],
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Locked ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
                }
            },
            {
                title: translations["locked_reason"] || 'Locked reason', field: 'LockedType',
                hidden: visible ? visible['LockedType'] : false,
                lookup: { 'not_for_sale': 'Not for sale & content may not be changed', 'no_products_may_be_added': 'No products may be added', 'no_products_may_be_removed': 'No products may be removed' },
                filterCellStyle: { minWidth: 380, maxWidth: 380 },
                filtering: true,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.LockedType === 'Not for sale & content may not be changed' ? translations['not_for_sale'] || 'Not for sale' : rowData.LockedType === 'No products may be added' ? translations['no_products_may_be_added'] || 'No products may be added' : rowData.LockedType === 'No products may be removed' ? translations['no_products_may_be_removed'] || 'No products may be removed' : translations['short_not_assigned'] || 'n/a'}</Typography>;
                }
            },
            {
                title: translations["grade_condition"] || 'Grades (condition)', field: 'Grade',
                hidden: visible ? visible['Grade'] : false,
                filtering: true,
                lookup: grades,
                render: rowData => {
                    return rowData.Grades.length > 0 ? rowData.Grades.slice(0, 3).map((grade, index) => {
                        return <Typography key={grade.GradeID} variant={'caption'}>{grade.InternationalGrading}{index !== 2 ? <br /> : '...'}</Typography>;
                    }) : <Typography variant={'caption'}> n/a </Typography>;
                }
            },
            {
                title: translations["allowed_product_types"] || 'Allowed Product types', field: 'ProductTypeKeys',
                hidden: visible ? visible['ProductTypeKeys'] : false,
                filterCellStyle: { minWidth: 150, maxWidth: 150 },
                filtering: true,
                lookup: productTypes,
                render: rowData => {
                    return rowData.ProductTypes.length > 0 ? rowData.ProductTypes.slice(0, 3).map((productType, index) => {
                        return <Typography key={productType.ProductTypeID} variant={'caption'}>{productType.Name}{index !== 2 ? <br /> : '...'}</Typography>;
                    }) : <Typography variant={'caption'}> n/a </Typography>;
                }
            },
            {
                title: translations["deleted"] || 'Deleted', field: 'Deleted',
                hidden: visible ? visible['Deleted'] : false,
                lookup: { '1': translations['yes'] || 'Yes', '0': translations['no'] || 'No' },
                defaultFilter: ['0'],
                filtering: true,
                width: 100,
                render: rowData => {
                    return <Typography variant={'caption'}>{rowData.Deleted ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
                }
            }
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classes, translations, visible, grades, productTypes, colliTypes, activeWarehouseID, groupsLookup])


    const goToColliDetails = (_event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, colliID: rowData.ColliInventoryID, redirectPath: `/container/edit`, search: `ColliID=${rowData.ColliID}`, warehouseID: rowData?.Warehouse?.WarehouseID, warehouseInventoryID: rowData?.Warehouse?.WarehouseInventoryID });
    };

    const restoreColli = async (_event, rowData) => {
        const colliID = rowData.ColliID;
        await onRestoreColli({ ActiveCustomerID: activeCustomer, ColliID: colliID });
    };

    const generateReports = useCallback(async (formData) => {
        const exportFormatKeys = Object.keys(formData).filter(key => ["Excel", "JSON", "XML", "CSV"].includes(key));
        const exportFormats = [];
        for (const key of exportFormatKeys) {
            if (formData[key]) {
                const exportFormat = {};
                switch (key) {
                    case "Excel":
                        exportFormat.xlsx = { individualAssets: !!formData?.individualExcelReports };
                        break;
                    case "JSON":
                        exportFormat.json = { individualAssets: !!formData?.individualJsonReports };
                        break;
                    case "XML":
                        exportFormat.xml = { individualAssets: !!formData?.individualXmlReports };
                        break;
                    case "CSV":
                        exportFormat.csv = { individualAssets: !!formData?.individualCsvReports };
                        break;
                }
                exportFormats.push(exportFormat);
            }
        }

        const outputModes = Object.keys(formData).filter(key => ["Download", "Email"].includes(key)).filter((key) => formData[key]);

        const dataToSend = {
            ActiveCustomerID: activeCustomer,
            CollectionType: 'colli_collection',
            ExportFormats: exportFormats,
            OutputModes: outputModes.map(item => item.toLowerCase()),
            includePDFReports: formData.includePDFReports,
            includeAggregatedPDFErasureReports: formData.includeAggregatedPDFErasureReports,
            includeAggregatedPDFVerificationReports: formData.includeAggregatedPDFVerificationReports,
            includeSummaryPDFErasureReports: formData.includeSummaryPDFErasureReports,
            includeSummaryPDFVerificationReports: formData.includeSummaryPDFVerificationReports,
            includeDiagnoseReports: formData.includeDiagnoseReports,
            includeVerificationReports: formData.includeVerificationReports,
            GroupID: formData.GroupID,
            generateNew: formData.generateNew,
            CollectionTypeID: rowData.ColliID,
        }
        await onGenerateReport(dataToSend, translations);
        setCollectionCreatePopupIsOpen(false)
    }, [activeCustomer, onGenerateReport, rowData]);

    const goToPCProducts = (_event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, colliID: rowData.ColliInventoryID, redirectPath: `/products/pc-products`, search: `ColliInventoryID=${rowData.ColliInventoryID}`, warehouseID: rowData?.Warehouse?.WarehouseID, warehouseInventoryID: rowData?.Warehouse?.WarehouseInventoryID })
    };

    const goToMobileProducts = (_event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, colliID: rowData.ColliInventoryID, redirectPath: `/products/mobile-products`, search: `ColliInventoryID=${rowData.ColliInventoryID}`, warehouseID: rowData?.Warehouse?.WarehouseID, warehouseInventoryID: rowData?.Warehouse?.WarehouseInventoryID })
    };

    const goToStorageProducts = (_event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, colliID: rowData.ColliInventoryID, redirectPath: `/products/storage-products`, search: `ColliInventoryID=${rowData.ColliInventoryID}`, warehouseID: rowData?.Warehouse?.WarehouseID, warehouseInventoryID: rowData?.Warehouse?.WarehouseInventoryID })
    };

    const goToColliHistory = (event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, colliID: rowData.ColliInventoryID, redirectPath: `/logistic/colli-history`, search: `WarehouseInventoryID=${rowData.Warehouse.WarehouseInventoryID}`, warehouseID: rowData?.Warehouse?.WarehouseID, warehouseInventoryID: rowData?.Warehouse?.WarehouseInventoryID })
    }

    const redirectHandler = (path, search, warehouseID, colliID = null, warehouseInventoryID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, colliID: colliID, redirectPath: path, search: search, warehouseID: warehouseID, warehouseInventoryID: warehouseInventoryID })
    };
    const goToDeleteColli = (ColliIDs) => {
        createHistory();
        setRedirectOptions({ redirect: true, colliID: ColliIDs, redirectPath: `/warehouse/delete`, search: '' });
    };
    const goToCreateColli = (colliType, warehouses) => {
        createHistory();
        setRedirectOptions({ redirect: true, colliID: null, redirectPath: `/logistic/warehouse/create`, search: `colliType=${colliType}${searchParams && searchParams.WarehouseInventoryID ? `&&WarehouseInventoryID=${warehouses.name[0].value}` : ''}` });
    };
    if (!hasAtLeastOnePermission(permissions, [
        "colli_load",
        "colli_generate_report",
        "product_list",
        "colli_palette_restore"
    ])) {
        tableColumns.shift();
    }

    if (redirectOptions.redirect) {
        return <Redirect to={{
            pathname: redirectOptions.redirectPath,
            search: redirectOptions.search,
            state: { WarehouseID: redirectOptions.warehouseID, WarehouseInventoryID: redirectOptions.warehouseInventoryID, ColliID: redirectOptions.colliID }
        }} />;
    }

    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={checkIfLoading(loading)} PaperProps={{ classes: { root: classes.loading } }}>
        <AppLogoLoading />
    </Dialog>;

    return (
        hasPermission(permissions, 'colli_list') ?
            grades && productTypes && warehouseActive.loading ?
                <>
                    {!warehouseActive.open ?
                        loading.groups ? loadingScreen :

                            <div className={classes.root}>
                                <ColliList
                                    goToCreateColli={goToCreateColli}
                                    warehouseActive={warehouseActive}
                                    setWarehouseActive={setWarehouseActive}
                                    tableColumns={tableColumns}
                                    goToDeleteColli={goToDeleteColli}
                                    redirectHandler={redirectHandler}
                                    tableRef={tableRef}
                                />
                            </div> :
                        <ActiveWarehouseForm setWarehouseActive={setWarehouseActive} handleCloseActiveWarehouseForm={() => setWarehouseActive({ ...warehouseActive, open: false })} warehouses={warehouseActive} />
                    }
                    {
                        <>
                            <Dialog classes={{ paper: classes.dialogPaper }} onClose={() => setCollectionCreatePopupIsOpen(false)} aria-labelledby="customized-dialog-title" open={collectionCreatePopupIsOpen} fullWidth={true}
                                maxWidth={'md'} >
                                <DialogTitle className={classes.title}>{`${translations["create_collection"] || "Create collection"}`} </DialogTitle>
                                <Grid container >
                                    <Grid item xs={12}>
                                        <ExportForm
                                            setIsOpen={collectionCreatePopupIsOpen}
                                            initialValues={initialValues}
                                            formSettings={formSettings}
                                            translations={translations}
                                            handleDownload={generateReports}
                                            groups={groupsLookup ? Object.keys(groupsLookup).map(key => ({ value: key, displayValue: groupsLookup[key] })) : []}
                                            showProductOverviewExportTypes={true}
                                            showProductOverviewOutputMode={true}
                                        />
                                    </Grid>
                                </Grid>
                            </Dialog>
                            {confirmDialog.open && <ConfirmationDialog
                                isOpen={confirmDialog.open}
                                title={confirmDialog.title}
                                contentText={translations['it_could_slow_down_live_message_sending'] || `It could slow down the sending of "live" messages to external systems.`}
                                onYes={() => setConfirmDialog({ open: false, confirmed: true, type: confirmDialog.type })}
                                onCancel={() => setConfirmDialog({ open: false, confirmed: false, type: confirmDialog.type })}
                                textCancel={translations['cancel'] || 'Cancel'}
                                textYes={translations['send'] || 'Send'}
                            />}
                        </>
                    }
                </> : <CircularProgress size={24} /> : null
    );
};

const CustomChip = props => {
    const { keyValue, value, className } = props;
    let possibleStyles = {
        warning: {
            color: informationColors.warning.light
        },
        error: {
            color: informationColors.error.dark,
        },
        success: {
            color: informationColors.success.main
        }
    }
    return (
        <Typography key={keyValue} className={className} style={possibleStyles[className]}>{value === 'n/a' ? value : capitalize(value)}</Typography>
    );
};

const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}


const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        activeWarehouseID: state.core.login.user.ActiveWarehouseID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
        colli: state.logistic.colli,
        fetching: state.logistic.colli.fetching
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchWarehouse: (params) => dispatch(actions.listWarehouse(params)),
        setActiveWarehouse: (params) => dispatch(actions.setActiveWarehouse(params)),
        onFetchGrades: (params) => dispatch(actions.fetchGrades(params)),
        onFetchColliType: (params) => dispatch(actions.fetchColliType(params)),
        onFetchProductType: filter => dispatch(actions.listProductTypes(filter)),
        onGenerateReport: (colli, translations) => dispatch(actions.generateReport(colli, translations)),
        onRestoreColli: colli => dispatch(actions.restoreColli(colli)),
        fetchGroups: params => dispatch(groupActions.fetchGroups(params)),
        onSendExternalData: params => dispatch(pcActions.sendExternalData(params)),
        onSendErasureReports: params => dispatch(pcActions.sendErasureReports(params)),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(Colli));


/**
 * Translations:
 *  action
 *  edit_colli
 *  status
 *  created_at
 *  last_modified_at
 *
 */